export const FETCH_CLIENTS = "FETCH_CLIENTS";
export const FETCH_CLIENTS_SYNC = "FETCH_CLIENTS_SYNC";
export const LOADING_CLIENTS = "LOADING_CLIENTS";
